/**
 * InspectorMessage.jsx
 * Component to display informational messages in the Inspector, instead of the primary content.
 */
export default function InspectorMessage({ children, style={} }) {
    return (
        <span style={{ padding: '1.5em', fontStyle: 'italic', ...style }}>{children}</span>
    );
}
